export { default } from './TaggisAndDocBrowserView';



// WEBPACK FOOTER //
// ./src/components/views/TaggisAndDocBrowserView/index.js